import { ApplicationConfig, inject, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
    import { provideAnimations } from '@angular/platform-browser/animations';

const profile: OepaAuthProfile = {
  clientId: environment.clientID,
  redirectUri: environment.redirectURI
}

import { routes } from './app.routes';
import { OepaAuthProfile, OepaIopAuthLibService } from '@ohioepa/oepa-iop-auth-lib';
import { environment } from '../environments/environment';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { OAuthService, provideOAuthClient, UrlHelperService } from 'angular-oauth2-oidc';
import { JWTHttpInterceptor } from './shared/jwt-http-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: OepaIopAuthLibService,
      useFactory: () => {
        return new OepaIopAuthLibService(inject(OAuthService), profile)
      }
    },
    provideOAuthClient(),
    UrlHelperService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JWTHttpInterceptor,
      multi: true
    }
  ]
};
